export const analyticsDashboardUrl =
  process.env.REACT_APP_CLOUDFLARE_ANALYTICS_URL ?? "https://dash.cloudflare.com";

export const isAnalyticsConfigured = Boolean(
  process.env.REACT_APP_CLOUDFLARE_ANALYTICS_URL,
);

// Cloudflare Web Analytics (free tier) records pageviews automatically via
// the beacon script in public/index.html. Custom events are not supported
// on the free tier, so this is a no-op kept for call-site compatibility —
// swap in GA4, PostHog, or CloudWatch RUM later if you need event tracking.
export const trackEvent = (
  _name: string,
  _properties?: Record<string, string | number | boolean | null>,
): void => {
  /* no-op on free-tier Cloudflare Web Analytics */
};
